<spike-base-page [breadcrumbItems]="breadcrumbItems()" [title]="title()" [subTitle]="subTitle()">
    <div class="spike-card">
        @for (entityType of modelConfigList; track $index) {
            <div class="mb-4">
                <div class="flex justify-between">
                    <div class="font-semibold text-xl">{{entityType.label}}</div>
                    <div>
                        <p-button 
                            (click)="onSelect(entityType)"
                            icon="pi pi-pencil" 
                            severity="info"    
                            label="Modifica">
                        </p-button>
                    </div>
                </div>
            </div>
        <p-divider></p-divider>
        }
</div>
</spike-base-page>

@if(isDialogVisible()){
<p-drawer [header]="'Modello ' + selectedModelConfig()?.label" [(visible)]="isDialogVisible"  position="right" styleClass="!w-full md:!w-80 lg:!w-[40rem]">
    @if(selectedModel()){
        <spike-model-form [entityModel]="selectedModel()!" (onSave)="onSave($event)"></spike-model-form>
    }
     <ng-template #footer>
     </ng-template>
</p-drawer>
}